import { useCallback, useMemo } from "react";
import { useAppDispatch, useRootState } from "./index";
import { NotificationDTO } from "../../types/workgroup";
import { SetGetPolicyReqDTO } from "../api/PolicyApi";
import {
  trunkSetpolicyList,
  trunkGetpolicyList,
  trunkSetPoliciesList,
  trunkSetLinkFilePolicy,
  trunkGetLinkFilePolicy,
  trunkCheckFilePWValid,
  trunkGetPolicyNoti,
  trunkUpdatePolicyNoti,
  trunkGetMSAppConfig,
} from "../store/policy";

// # hooks
// eslint-disable-next-line @typescript-eslint/explicit-function-return-type
const usePolicyStore = () => {
  const policyState = useRootState((state) => state.policyStore);

  const dispatch = useAppDispatch();
  const boundSetPolicy = useCallback(
    (reqDto: SetGetPolicyReqDTO) => dispatch(trunkSetpolicyList(reqDto)).then(),
    [dispatch]
  );
  const boundGetPolicy = useCallback(
    (reqDto: SetGetPolicyReqDTO) => dispatch(trunkGetpolicyList(reqDto)).then(),
    [dispatch]
  );
  const boundSetPolicies = useCallback(
    (reqDto: SetGetPolicyReqDTO) =>
      dispatch(trunkSetPoliciesList(reqDto)).then(),
    [dispatch]
  );
  const boundSetLinkFilePolicy = useCallback(
    (reqDto: SetGetPolicyReqDTO) =>
      dispatch(trunkSetLinkFilePolicy(reqDto)).then(),
    [dispatch]
  );
  const boundGetLinkFilePolicy = useCallback(
    (reqDTO: SetGetPolicyReqDTO) =>
      dispatch(trunkGetLinkFilePolicy(reqDTO)).then(),
    [dispatch]
  );
  const boudnCheckFilePWValid = useCallback(
    (reqDTO: { uuid: string; password: string }) =>
      dispatch(trunkCheckFilePWValid(reqDTO)).then(),
    [dispatch]
  );
  const boundGetPolicyNoti = useCallback(
    () => dispatch(trunkGetPolicyNoti()).then(),
    [dispatch]
  );
  const boundUpdatePolicyNoti = useCallback(
    (workgroupId: string, req: NotificationDTO) =>
      dispatch(trunkUpdatePolicyNoti(req)).then(),
    [dispatch]
  );
  const boundGetMSAppConfig = useCallback(
    () => dispatch(trunkGetMSAppConfig()).then(),
    [dispatch]
  );

  return {
    policyState,
    setFilePolicy: boundSetPolicy,
    getFilePolicy: boundGetPolicy,
    setFilePolicies: boundSetPolicies,
    setLinkFilePolicy: boundSetLinkFilePolicy,
    getLinkFilePolicy: boundGetLinkFilePolicy,
    checkFilePWValid: boudnCheckFilePWValid,
    getPolicyNoti: boundGetPolicyNoti,
    updatePolicyNoti: boundUpdatePolicyNoti,
    getMSAppConfig: boundGetMSAppConfig,
  };
};

export default usePolicyStore;
